"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preloadImage = void 0;
/**
 * 预加载图片
 * @param url
 */
function preloadImage(url) {
    return new Promise(function (resolve, reject) {
        var imageDom = document.createElement('img');
        imageDom.onload = function () {
            resolve(imageDom);
        };
        imageDom.onerror = function () {
            reject(new Error("\u56FE\u7247preload\u5931\u8D25: ".concat(url)));
        };
        imageDom.src = url;
    });
}
exports.preloadImage = preloadImage;
exports.default = { preloadImage: preloadImage };
